import React, { Component } from "react";
import * as firebase from 'firebase'
import {db} from '../../utils/ipa.js';
import {
    Container,
    Header,
    Title,
    Button,
    IconNB,
    DeckSwiper,
    Card,
    CardItem,
    Icon,
    Thumbnail,
    Text,
    Left,
    Right,
    Body,
    Footer,
    List, ListItem,Content
  } from "native-base";

export default function MatchingDataScreen({ routes,navigation }) {
     
    const docRef = db.collection('Profiles').doc('8mDwUl4dxOINX3HWdqWt');

    docRef.update({
        TEST: 'Hello 2',
        TEST1: "Hello World",
        Data: true
      });

    return (
        <Container>
            <Text>Matching Data</Text>
        </Container>
    )
}
